export default {
  shadows: {
    nav: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    dropdown: '0px 3px 5px rgba(74, 82, 89, 0.2)',
    progress: '0 3px 6px rgba(74, 82, 89, 0.4)'
  }
};
